import axios from "axios";
import { Auth } from "aws-amplify";

// const BASE_URL = "http://localhost:4000";
const BASE_URL = process.env.REACT_APP_PAY_API_URL || "https://api.linkbase.ca";
const API_KEY = process.env.REACT_APP_LINKBASE_API_KEY;

export async function api(path, body = {}) {
  const { data } = await axios.post(`${BASE_URL}${path}`, body, {
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
    },
  });
  return data;
}

export async function apiAuth(path, body = {}) {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  const { data } = await axios.post(`${BASE_URL}${path}`, body, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
    },
  });
  return data;
}

export async function apiGet(path, params = {}) {
  const { data } = await axios.get(`${BASE_URL}${path}`, {
    params,
    headers: {
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
    },
  });
  return data;
}

export async function apiGetAuth(path, params = {}) {
  const session = await Auth.currentSession();
  const token = session.getIdToken().getJwtToken();
  const { data } = await axios.get(`${BASE_URL}${path}`, {
    params,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      "x-api-key": API_KEY,
    },
  });
  return data;
}
